import React, { FC, InputHTMLAttributes } from "react"
import clsx from "clsx"

export interface ManualInputProps extends InputHTMLAttributes<any> {
  errorText?: string
  isNumber?: boolean
  inputClassName?: string
}

export const ManualInput: FC<ManualInputProps> = ({
  errorText,
  isNumber,
  inputClassName,
  value,
  className,
  ...props
}) => {
  return (
    <div className={clsx("relative", className)}>
      <input
        type={isNumber ? "number" : "text"}
        {...props}
        className={clsx(
          inputClassName,
          "py-2.5 px-3 rounded w-full border-2 border-grey-ec lg:text-base",
          "focus:outline-none focus:shadow-outline focus:border-green active:shadow-outline active:border-green text-sm",
          value && !errorText && "border-2 !border-green",
          errorText && "!border-red border"
        )}
      />
      <small className="text-red absolute -bottom-4 left-0">{errorText}</small>
    </div>
  )
}
